export default "__VITE_ASSET__C_ul6VWn__"